import React, { useState } from 'react';
import {Button, TextField, Box, Typography, Container, Alert} from '@mui/material';
import {userLogin} from "../Users/UsersClient";
import {changeUserProfile} from "./userProfileSlice";
import {useDispatch} from "react-redux";

function Login() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');

    const dispatchData = useDispatch();


    const handleSubmit = (event) => {
        event.preventDefault();
        console.log("BASE_URL", import.meta.env.VITE_BACKEND_URL);
        userLogin(username, password)
            .then(data => {
                if (!data || data.users?.length === 0) {
                    setAlertMessage('Login failed.');
                    setShowAlert(true);
                    return;
                }

                localStorage.setItem('token', data.token);
                localStorage.setItem('userId', data.users[0].id);
                localStorage.setItem('userName', data.users[0].userName);
                localStorage.setItem('firstName', data.users[0].firstName);
                localStorage.setItem('lastName', data.users[0].lastName);
                localStorage.setItem('department', data.users[0].department);
                localStorage.setItem('rights', data.users[0].rights);
                localStorage.setItem('role', data.users[0].role);
                localStorage.setItem('hideActions', JSON.stringify(data.users[0].rights !== "Super User"));

                dispatchData(changeUserProfile({
                    id: data.users[0].id,
                    firstName: data.users[0].firstName,
                    lastName: data.users[0].lastName,
                    department: data.users[0].department,
                    role: data.users[0].role,
                    status: data.users[0].status,
                    rights: data.users[0].rights,
                    approvalLimit: data.users[0].approvalLimit,
                    userName: data.users[0].userName,
                    createdOn: data.users[0].createdOn,
                    createdBy: data.users[0].createdBy,
                    lastModifiedOn: data.users[0].lastModifiedOn,
                    lastModifiedBy: data.users[0].lastModifiedBy
                }));

                setShowAlert(false);
            })
            .catch(error => {
                console.error('There was an error!', error);
                setAlertMessage('Login failed: ' + error.message);
                setShowAlert(true);
            });
    }
    //     userLogin(username, password)
    //         .then(response => {
    //             // Assuming the token is set as a cookie in the server's response
    //             if (response.status === 200) {
    //                 return response.data;  // Assuming the user data is in response.data
    //             } else {
    //                 throw new Error('Login failed');
    //             }
    //         })
    //         .then(data => {
    //             if (data.length === 0) {
    //                 setAlertMessage('Login failed.');
    //                 setShowAlert(true);
    //             } else {
    //                 localStorage.setItem('token', data.token);
    //                 // localStorage.setItem('userInfo', JSON.stringify(data.users[0]));
    //                 localStorage.setItem('userId', data.users[0].id);
    //                 localStorage.setItem('userName', data.users[0].userName);
    //                 localStorage.setItem('firstName', data.users[0].firstName);
    //                 localStorage.setItem('lastName', data.users[0].lastName);
    //                 localStorage.setItem('department', data.users[0].department);
    //                 localStorage.setItem('rights', data.users[0].rights);
    //                 localStorage.setItem('role', data.users[0].role);
    //                 localStorage.setItem('hideActions', JSON.stringify(data.users[0].rights !== "Super User"));
    //                 console.log("Here's my user id stored in local storage: ", localStorage.getItem('userId'));
    //                 console.log("Here's my userName stored in local storage: ", localStorage.getItem('userName'));
    //                 console.log("Here's my firstName stored in local storage: ", localStorage.getItem('firstName'));
    //                 console.log("Here's my lastName stored in local storage: ", localStorage.getItem('lastName'));
    //                 console.log("Here's my department stored in local storage: ", localStorage.getItem('department'));
    //                 console.log("Here's my rights stored in local storage: ", localStorage.getItem('rights'));
    //                 console.log("Here's my role stored in local storage: ", localStorage.getItem('role'));
    //
    //
    //                 dispatchData(changeUserProfile({
    //                     id: data.users[0].id,
    //                     firstName: data.users[0].firstName,
    //                     lastName: data.users[0].lastName,
    //                     department: data.users[0].department,
    //                     role: data.users[0].role,
    //                     status: data.users[0].status,
    //                     rights: data.users[0].rights,
    //                     approvalLimit: data.users[0].approvalLimit,
    //                     userName: data.users[0].userName,
    //                     createdOn: data.users[0].createdOn,
    //                     createdBy: data.users[0].createdBy,
    //                     lastModifiedOn: data.users[0].lastModifiedOn,
    //                     lastModifiedBy: data.users[0].lastModifiedBy
    //                 }));
    //
    //                 // Clear the alert
    //                 setShowAlert(false);
    //
    //                 // Token is already set in the cookie by the server, no need to manually store it
    //             }
    //         })
    //         .catch(error => {
    //             console.error('There was an error!', error);
    //             setAlertMessage('Login failed: ' + error.message);
    //             setShowAlert(true);
    //         });
    // };



    return (
        <Container component="main" maxWidth="xs">
            <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Typography component="h1" variant="h5">
                    Contramatic sign in
                </Typography>
                <Box component="form" onSubmit={handleSubmit} noValidate sx={{mt: 1}}>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="username"
                        label="Username"
                        name="username"
                        autoComplete="username"
                        autoFocus
                        value={username}
                        onChange={e => setUsername(e.target.value)}
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Password"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{mt: 3, mb: 2}}
                    >
                        Sign In
                    </Button>
                </Box>
                {showAlert && (
                    <Alert severity="error"
                           onClick={() => setShowAlert(false)}
                    >{alertMessage}</Alert>
                )}
            </Box>
        </Container>
    );
}

export default Login;
